<template>
  <c-sidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="value => $store.commit('set', ['sidebarShow', value])"
  >
    <c-sidebar-brand class="d-md-down-none" to="/" style="background-color: #00D1B2">
      <img
        class="c-sidebar-brand-full c-avatar-img"
        src="img/logos/longboss.svg"
        alt="KoalaBoss"
        style="height: 35px; width: auto"
      />
      <!--      <CIcon-->
      <!--        class="c-sidebar-brand-full"-->
      <!--        name="logo"-->
      <!--        size="custom-size"-->
      <!--        :height="35"-->
      <!--        viewBox="0 0 556 134"-->
      <!--      />-->
      <img
        class="c-sidebar-brand-minimized"
        src="img/logos/koalaboss-body-icon.svg"
        alt="KoalaBoss"
        style="height: 35px; width: auto"
      />
      <!--      <CIcon -->
      <!--        class="c-sidebar-brand-minimized" -->
      <!--        name="logo" -->
      <!--        size="custom-size"-->
      <!--        :height="35"-->
      <!--        viewBox="0 0 110 134"-->
      <!--      />-->
    </c-sidebar-brand>
    <c-render-function flat :content-to-render="$options.nav" />
    <c-sidebar-minimizer class="c-d-md-down-none" @click.native="setShowSidebar" />
  </c-sidebar>
</template>

<script>
import nav from './_nav';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    setShowSidebar() {
      const currentSetting = this.$store.state.sidebarMinimize;
      this.$store.commit('toggle', 'sidebarMinimize');
      // Save to user
      const data = {
        preferenceKey: 'sidebarMinimize',
        preferenceValue: !currentSetting,
      };
      this.$http.put(buildEndpoint('account/preferences/save'), data);
    },
  },
};
</script>
